<template>
  <TableList
    v-loading="loading"
    class="ambassador-management-list"
    noOperation
    :title="$t(`${i18nPrefix}.title.jobPosterAmbassadorUpload`)"
    :listData="ambassadorList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    :showCreateBtn="false"
  >
    <template #btn>
      <el-button class="upload-btn" @click="dialogVisible = true">{{ $t(`${i18nPrefix}.btn.upload`) }}</el-button>
      <el-button class="blue-btn" @click="handelAddAmbassador">{{ $t(`${i18nPrefix}.btn.addAmbassador`) }}</el-button>
    </template>
    <template #page-bottom>
      <DialogWrapper
        :show.sync="dialogVisible"
      >
      <div>
          <label>1. </label>
          <el-button type="text" class="template-link" href="" @click="downloadTemplate">{{ $t(`${i18nPrefix}.btn.downloadTemplate`) }}</el-button>
        </div>
        <div class="upload-input">
          <div class="file-type-tip"><label>2. {{ $t(`${i18nPrefix}.label.excelInput`) }}</label></div>
          <el-input v-model="file.name" readonly="readonly" type="text" id="show_file" class="select-file-input" />
          <el-button class="select-file-btn" size="small" @click="selectFile">{{ $t(`${i18nPrefix}.btn.selectFile`) }}</el-button>
        </div>
        <div>
          <span v-show="showUploadTip" class="file-error-tip">{{ $t(`${i18nPrefix}.message.uploadTip`) }}</span>
          <input type="file" ref="uploadFile" class="upload-file" @change="fileChange" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="upload-cancel" size="small" @click="handleClose">{{ $t(`${i18nPrefix}.btn.cancelUpload`) }}</el-button>
          <el-button class="upload-submit" size="small" @click="uploadAmbassador">{{ $t(`${i18nPrefix}.btn.ConfirmUpload`) }}</el-button>
        </span>
      </DialogWrapper>
    </template>
    <template #switchButton="{ row }">
      <div class="switch-container">
        <el-switch
          v-model="row.is_enabled"
          active-color="#13ce66"
          @change="changeStatus(row)"
        >
        </el-switch>
      </div>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    TableList,
    DialogWrapper
  },
  data () {
    return {
      i18nPrefix: 'admin.company.jobPoster',
      file: {
        lastModified: null,
        lastModifiedDate: null,
        name: '',
        size: null,
        type: '',
        webkitRelativePath: ''
      },
      fileType: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/wps-office.xlsx'],
      ambassadorList: [],
      dialogVisible: false,
      showUploadTip: false,
      actionBtn: {
        edit: {
          show: true,
          onclick: this.handleEditAmbassador
        }
      },
      loading: false
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.email`),
          dataKey: 'email_address',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.phone`),
          dataKey: 'phone',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.name`),
          dataKey: 'name',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.ambassadorStatus`),
          dataKey: 'is_enabled',
          slotName: 'switchButton'
        }
      ]
      return columns
    }
  },
  created () {
    this.getAmbassadorList()
  },
  methods: {
    ...mapActions('jobPosterAmbassador', ['uploadJobPosterAmbassador', 'getJobPosterAmbassadorList', 'updateJobPosterAmbassador']),
    async getAmbassadorList () {
      this.loading = true
      try {
        const resp = await this.getJobPosterAmbassadorList()
        if (resp) {
          _.forEach(resp.ambassador_list, item => {
            item.is_enabled = !item.is_deleted
          })
          this.ambassadorList = resp.ambassador_list
        }
      } finally {
        this.loading = false
      }
    },
    async changeStatus (ambassadorInfo) {
      this.loading = true
      try {
        await this.updateJobPosterAmbassador({ id: ambassadorInfo.id, name: ambassadorInfo.name, is_enabled: ambassadorInfo.is_enabled })
      } finally {
        this.loading = false
      }
    },
    async uploadAmbassador () {
      if (this.handleBeforeUpload(this.file)) {
        this.dialogVisible = false
        const resp = await this.uploadJobPosterAmbassador(this.file)
        if (resp) {
          this.$message({
            message: this.$t(`${this.i18nPrefix}.message.uploadAmbassadorSuccess`, { successCount: resp.success_count, failCount: resp.error_info_list.length }),
            duration: 2000,
            type: 'success'
          })
          this.getAmbassadorList()
          this.clearFile()
        } else {
          this.handleUploadError()
        }
      }
    },
    handleBeforeUpload (file) {
      if (!this.fileType.includes(file.type)) {
        this.showUploadTip = true
        return false
      }
      return true
    },
    handleUploadError () {
      this.$message({
        message: this.$t(`${this.i18nPrefix}.message.uploadError`),
        duration: 2000,
        type: 'warning'
      })
    },
    clearFile () {
      this.$refs.uploadFile.value = ''
      this.file = {
        lastModified: null,
        lastModifiedDate: null,
        name: '',
        size: null,
        type: '',
        webkitRelativePath: ''
      }
    },
    selectFile () {
      this.clearFile()
      this.$refs.uploadFile.click()
      this.showUploadTip = false
    },
    fileChange () {
      this.file = this.$refs.uploadFile.files[0]
      if (!this.file) {
        this.file = {
          lastModified: null,
          lastModifiedDate: null,
          name: '',
          size: null,
          type: '',
          webkitRelativePath: ''
        }
      }
    },
    handleClose () {
      this.showUploadTip = false
      this.dialogVisible = false
      this.clearFile()
    },
    handelAddAmbassador () {
      this.$router.push('/v-admin/job-poster-ambassador/add')
    },
    handleEditAmbassador (row) {
      this.$router.push(`/v-admin/job-poster-ambassador/edit/${row.id}`)
    },
    downloadTemplate () {
      window.location.href = `${process.env.VUE_APP_BASE_URL}static/templates/AJINGA Ambassador Record Upload Template.xlsx`
    }
  }
}
</script>

<style lang="scss" scoped>
.ambassador-management-list {
  .upload-input {
    display: flex;
    align-items: center;

    .file-type-tip {
      margin-right: 8px;
    }
    .select-file-input {
      flex: 1;
    }
  }
  .upload-cancel {
    background-color: #aaa;
    color:#ffffff;
    width: 86px;
    margin-right: 30px;
    border-width: 0;
    font-weight: bold;
  }
  .upload-submit {
    width: 86px;
    background-color: #0096cc;
    color: #ffffff;
    border-width: 0;
    font-weight: bold;
  }

  .select-file-btn {
    margin-left: 5px;
    background-color: #aaa;
    color: #ffffff;
    width: 86px;
    border-width: 0;
    font-weight: bold;
  }
  .submit-upload {
    width: 30%;
    margin-left: 15px;
  }
  .upload-file {
    display: none;
  }

  .file-error-tip {
    margin-left: 10px;
    color: red;
  }
  ::v-deep {
    .el-dialog {
      width: 591px;
    }
    .el-dialog__body {
      padding: 30px 40px;
    }
  }
  ::v-deep {
    .table-header {
      height: 100%;
    }
    .select-file-tip {
      vertical-align: middle;
      font-size: 18px;
    }
  }
}
</style>
